<template>
  <TextEpsilon class="StoryProduct">
    <router-link
      v-if="category && slug"
      :to="{ name: 'program', params: { category, program: slug } }"
      v-html="name"
    />
    <span
      v-else
      v-html="name"
    />
  </TextEpsilon>
</template>

<script>
  import Program from '@/api/programs';
  import Category from '@/api/categories';

  import TextEpsilon from './TextEpsilon';

  export default {
    components: {
      TextEpsilon,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        name: undefined,
        slug: undefined,
        category: undefined,
      };
    },
    async created() {
      const {
        slug,
        title: {
          rendered: name,
        },
        'product-categories': categories,
      } = (await Program.find(this.id));

      this.name = name;
      this.slug = slug;
      this.category = (await Category.find(categories[0])).slug;
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .StoryProduct {
    color: color(light-grey);
    transition-property: color;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    &:hover {
      color: color(red);
      transition-timing-function: timing-function(decelerate);
    }

    .ViewStoriesStory__product:not(:last-child) & {
      margin-right: spacing(base-alpha);
      border-right: border(linen);
      padding-right: spacing(base-alpha);
    }
  }
</style>
